import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  row: {
    minHeight: 48,
    borderWidth: 1,
    borderRadius: theme.borderRadius.xs,
    paddingHorizontal: theme.spacing[4],
    paddingVertical: theme.spacing[3],
    justifyContent: 'center',
    gap: theme.spacing[3],
    variants: {
      selected: {
        true: {
          borderColor: 'transparent',
          backgroundColor: colors.backgroundPrimaryInverse,
        },
        false: {
          borderColor: colors.borderPrimary,
        },
      },
    },
  },
  labelRow: {
    alignItems: 'center',
  },
  badge: {
    width: 38,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  divider: {
    height: 1,
    variants: {
      selected: {
        true: { backgroundColor: colors.borderSubtle },
        false: { backgroundColor: colors.borderPrimary },
      },
    },
  },
  messageHidden: {
    height: 0,
    overflow: 'hidden',
    opacity: 0,
  },
}));
